import { BaleTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { WorkOrderInfo } from "./work-order.entity";

@Entity('work_order_items')
export class WorkOrderItems {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @Column('int',{
        name:'bale_id',
        nullable:false
    })
    baleId : number

    @Column('decimal',{
        name:'quantity',
        precision:10,scale:3,
        nullable:false
    })
    quantity : number

        @Column('varchar',{
        name:'lot_number',
        length:50,
        nullable:false
    })
    lotNumber : string

        @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_stock_in"
    })
    isStockIn: boolean;

    @ManyToOne(type => WorkOrderInfo, workOrder => workOrder.workOrderItems, { nullable: false, })
    @JoinColumn({ name: "work_order_id" })
      workOrderInfo: WorkOrderInfo;


}